import ReduxHelper from 'lib/ReduxHelper';

export const AUCTIONS_ACTION_TYPES = {
  AUCTIONS_FETCH_CURRENT: 'AUCTIONS_FETCH_CURRENT',
  AUCTIONS_FETCH_CURRENT_SUCCESS: 'AUCTIONS_FETCH_CURRENT_SUCCESS',
  AUCTIONS_FETCH_CURRENT_FAIL: 'AUCTIONS_FETCH_CURRENT_FAIL',
  AUCTIONS_CLEAR_CURRENT: 'AUCTIONS_CLEAR_CURRENT',

  AUCTIONS_FETCH_NEW: 'AUCTIONS_FETCH_NEW',
  AUCTIONS_FETCH_NEW_SUCCESS: 'AUCTIONS_FETCH_NEW_SUCCESS',
  AUCTIONS_FETCH_NEW_FAIL: 'AUCTIONS_FETCH_NEW_FAIL',
  AUCTIONS_CLEAR_NEW: 'AUCTIONS_CLEAR_NEW',

  AUCTIONS_FETCH_PENDINGAPPROVAL: 'AUCTIONS_FETCH_PENDINGAPPROVAL',
  AUCTIONS_FETCH_PENDINGAPPROVAL_SUCCESS:
    'AUCTIONS_FETCH_PENDINGAPPROVAL_SUCCESS',
  AUCTIONS_FETCH_PENDINGAPPROVAL_FAIL: 'AUCTIONS_FETCH_PENDINGAPPROVAL_FAIL',
  AUCTIONS_CLEAR_PENDINGAPPROVAL: 'AUCTIONS_CLEAR_PENDINGAPPROVAL',

  AUCTIONS_FETCH_NOOFFER: 'AUCTIONS_FETCH_NOOFFER',
  AUCTIONS_FETCH_NOOFFER_SUCCESS: 'AUCTIONS_FETCH_NOOFFER_SUCCESS',
  AUCTIONS_FETCH_NOOFFER_FAIL: 'AUCTIONS_FETCH_NOOFFER_FAIL',
  AUCTIONS_CLEAR_NOOFFER: 'AUCTIONS_CLEAR_NOOFFER',

  AUCTIONS_FETCH_FORSELECTION: 'AUCTIONS_FETCH_FORSELECTION',
  AUCTIONS_FETCH_FORSELECTION_SUCCESS: 'AUCTIONS_FETCH_FORSELECTION_SUCCESS',
  AUCTIONS_FETCH_FORSELECTION_FAIL: 'AUCTIONS_FETCH_FORSELECTION_FAIL',
  AUCTIONS_CLEAR_FORSELECTION: 'AUCTIONS_CLEAR_FORSELECTION',

  AUCTIONS_FETCH_PARTICIPATETO: 'AUCTIONS_FETCH_PARTICIPATETO',
  AUCTIONS_FETCH_PARTICIPATETO_SUCCESS: 'AUCTIONS_FETCH_PARTICIPATETO_SUCCESS',
  AUCTIONS_FETCH_PARTICIPATETO_FAIL: 'AUCTIONS_FETCH_PARTICIPATETO_FAIL',
  AUCTIONS_CLEAR_PARTICIPATETO: 'AUCTIONS_CLEAR_PARTICIPATETO',

  AUCTIONS_FETCH_ONLINE: 'AUCTIONS_FETCH_ONLINE',
  AUCTIONS_FETCH_ONLINE_SUCCESS: 'AUCTIONS_FETCH_ONLINE_SUCCESS',
  AUCTIONS_FETCH_ONLINE_FAIL: 'AUCTIONS_FETCH_ONLINE_FAIL',
  AUCTIONS_CLEAR_ONLINE: 'AUCTIONS_CLEAR_ONLINE',

  AUCTIONS_FETCH_FORACCEPTANCE: 'AUCTIONS_FETCH_FORACCEPTANCE',
  AUCTIONS_FETCH_FORACCEPTANCE_SUCCESS: 'AUCTIONS_FETCH_FORACCEPTANCE_SUCCESS',
  AUCTIONS_FETCH_FORACCEPTANCE_FAIL: 'AUCTIONS_FETCH_FORACCEPTANCE_FAIL',
  AUCTIONS_CLEAR_FORACCEPTANCE: 'AUCTIONS_CLEAR_FORACCEPTANCE',

  AUCTIONS_FETCH_REJECTED: 'AUCTIONS_FETCH_REJECTED',
  AUCTIONS_FETCH_REJECTED_SUCCESS: 'AUCTIONS_FETCH_REJECTED_SUCCESS',
  AUCTIONS_FETCH_REJECTED_FAIL: 'AUCTIONS_FETCH_REJECTED_FAIL',
  AUCTIONS_CLEAR_REJECTED: 'AUCTIONS_CLEAR_REJECTED',

  AUCTIONS_FETCH_FORDISPATCH: 'AUCTIONS_FETCH_FORDISPATCH',
  AUCTIONS_FETCH_FORDISPATCH_SUCCESS: 'AUCTIONS_FETCH_FORDISPATCH_SUCCESS',
  AUCTIONS_FETCH_FORDISPATCH_FAIL: 'AUCTIONS_FETCH_FORDISPATCH_FAIL',
  AUCTIONS_CLEAR_FORDISPATCH: 'AUCTIONS_CLEAR_FORDISPATCH',

  AUCTIONS_FETCH_DISPATCHPROBLEM: 'AUCTIONS_FETCH_DISPATCHPROBLEM',
  AUCTIONS_FETCH_DISPATCHPROBLEM_SUCCESS:
    'AUCTIONS_FETCH_DISPATCHPROBLEM_SUCCESS',
  AUCTIONS_FETCH_DISPATCHPROBLEM_FAIL: 'AUCTIONS_FETCH_DISPATCHPROBLEM_FAIL',
  AUCTIONS_CLEAR_DISPATCHPROBLEM: 'AUCTIONS_CLEAR_DISPATCHPROBLEM',

  AUCTIONS_FETCH_COMPLETED: 'AUCTIONS_FETCH_COMPLETED',
  AUCTIONS_FETCH_COMPLETED_SUCCESS: 'AUCTIONS_FETCH_COMPLETED_SUCCESS',
  AUCTIONS_FETCH_COMPLETED_FAIL: 'AUCTIONS_FETCH_COMPLETED_FAIL',
  AUCTIONS_CLEAR_COMPLETED: 'AUCTIONS_CLEAR_COMPLETED',

  AUCTIONS_FETCH_LOST: 'AUCTIONS_FETCH_LOST',
  AUCTIONS_FETCH_LOST_SUCCESS: 'AUCTIONS_FETCH_LOST_SUCCESS',
  AUCTIONS_FETCH_LOST_FAIL: 'AUCTIONS_FETCH_LOST_FAIL',
  AUCTIONS_CLEAR_LOST: 'AUCTIONS_CLEAR_LOST',

  AUCTIONS_FETCH_MERCHANT_SUMMARY: 'AUCTIONS_FETCH_MERCHANT_SUMMARY',
  AUCTIONS_FETCH_MERCHANT_SUMMARY_SUCCESS:
    'AUCTIONS_FETCH_MERCHANT_SUMMARY_SUCCESS',
  AUCTIONS_FETCH_MERCHANT_SUMMARY_FAIL: 'AUCTIONS_FETCH_MERCHANT_SUMMARY_FAIL',
  AUCTIONS_CLEAR_MERCHANT_SUMMARY: 'AUCTIONS_CLEAR_MERCHANT_SUMMARY',

  AUCTION_UPLOAD: 'AUCTION_UPLOAD',
  AUCTION_UPLOAD_SUCCESS: 'AUCTION_UPLOAD_SUCCESS',
  AUCTION_UPLOAD_FAIL: 'AUCTION_UPLOAD_FAIL',
  AUCTION_UPLOAD_CLEAR: 'AUCTION_UPLOAD_CLEAR',

  AUCTION_CREATE: 'AUCTION_CREATE',
  AUCTION_CREATE_SUCCESS: 'AUCTION_CREATE_SUCCESS',
  AUCTION_CREATE_FAIL: 'AUCTION_CREATE_FAIL',
  AUCTION_CREATE_CLEAR: 'AUCTION_CREATE_CLEAR',

  AUCTION_EDIT: 'AUCTION_EDIT',
  AUCTION_EDIT_SUCCESS: 'AUCTION_EDIT_SUCCESS',
  AUCTION_EDIT_FAIL: 'AUCTION_EDIT_FAIL',
  AUCTION_EDIT_CLEAR: 'AUCTION_EDIT_CLEAR',

  AUCTION_FETCH: 'AUCTION_FETCH',
  AUCTION_FETCH_SUCCESS: 'AUCTION_FETCH_SUCCESS',
  AUCTION_FETCH_FAIL: 'AUCTION_FETCH_FAIL',
  AUCTION_CLEAR: 'AUCTION_CLEAR',

  AUCTION_FETCH_BIDS: 'AUCTION_FETCH_BIDS',
  AUCTION_FETCH_BIDS_SUCCESS: 'AUCTION_FETCH_BIDS_SUCCESS',
  AUCTION_FETCH_BIDS_FAIL: 'AUCTION_FETCH_BIDS_FAIL',
  AUCTION_CLEAR_BIDS: 'AUCTION_CLEAR_BIDS',

  AUCTION_FETCH_IMAGES: 'AUCTION_FETCH_IMAGES',
  AUCTION_FETCH_IMAGES_SUCCESS: 'AUCTION_FETCH_IMAGES_SUCCESS',
  AUCTION_FETCH_IMAGES_FAIL: 'AUCTION_FETCH_IMAGES_FAIL',
  AUCTION_CLEAR_IMAGES: 'AUCTION_CLEAR_IMAGES',

  AUCTIONS_REMOVE_IMAGE_LICENSE_PLATE: 'AUCTIONS_REMOVE_IMAGE_LICENSE_PLATE',
  AUCTIONS_REMOVE_IMAGE_LICENSE_PLATE_SUCCESS:
    'AUCTIONS_REMOVE_IMAGE_LICENSE_PLATE_SUCCESS',
  AUCTIONS_REMOVE_IMAGE_LICENSE_PLATE_FAIL:
    'AUCTIONS_REMOVE_IMAGE_LICENSE_PLATE_FAIL',
  AUCTIONS_CLEAR_REMOVE_IMAGE_LICENSE_PLATE:
    'AUCTIONS_CLEAR_REMOVE_IMAGE_LICENSE_PLATE',

  AUCTION_UPLOAD_IMAGES: 'AUCTION_UPLOAD_IMAGES',
  AUCTION_UPLOAD_IMAGES_SUCCESS: 'AUCTION_UPLOAD_IMAGES_SUCCESS',
  AUCTION_UPLOAD_IMAGES_FAIL: 'AUCTION_UPLOAD_IMAGES_FAIL',
  AUCTION_CLEAR_UPLOAD_IMAGES: 'AUCTION_CLEAR_UPLOAD_IMAGES',

  AUCTION_DELETE_IMAGES: 'AUCTION_DELETE_IMAGES',
  AUCTION_DELETE_IMAGES_SUCCESS: 'AUCTION_DELETE_IMAGES_SUCCESS',
  AUCTION_DELETE_IMAGES_FAIL: 'AUCTION_DELETE_IMAGES_FAIL',
  AUCTION_CLEAR_DELETE_IMAGES: 'AUCTION_CLEAR_DELETE_IMAGES',

  AUCTION_REORDER_IMAGES: 'AUCTION_REORDER_IMAGES',
  AUCTION_REORDER_IMAGES_SUCCESS: 'AUCTION_REORDER_IMAGES_SUCCESS',
  AUCTION_REORDER_IMAGES_FAIL: 'AUCTION_REORDER_IMAGES_FAIL',
  AUCTION_CLEAR_REORDER_IMAGES: 'AUCTION_CLEAR_REORDER_IMAGES',

  AUCTION_FETCH_COMMENTS: 'AUCTION_FETCH_COMMENTS',
  AUCTION_FETCH_COMMENTS_SUCCESS: 'AUCTION_FETCH_COMMENTS_SUCCESS',
  AUCTION_FETCH_COMMENTS_FAIL: 'AUCTION_FETCH_COMMENTS_FAIL',
  AUCTION_CLEAR_COMMENTS: 'AUCTION_CLEAR_COMMENTS',

  AUCTION_FETCH_PARTS: 'AUCTION_FETCH_PARTS',
  AUCTION_FETCH_PARTS_SUCCESS: 'AUCTION_FETCH_PARTS_SUCCESS',
  AUCTION_FETCH_PARTS_FAIL: 'AUCTION_FETCH_PARTS_FAIL',
  AUCTION_CLEAR_PARTS: 'AUCTION_CLEAR_PARTS',

  AUCTIONS_CLEAR: 'AUCTIONS_CLEAR',

  AUCTIONS_START: 'AUCTIONS_START',
  AUCTIONS_START_SUCCESS: 'AUCTIONS_START_SUCCESS',
  AUCTIONS_START_FAIL: 'AUCTIONS_START_FAIL',

  AUCTION_END: 'AUCTION_END',
  AUCTION_END_SUCCESS: 'AUCTION_END_SUCCESS',
  AUCTION_END_FAIL: 'AUCTION_END_FAIL',

  AUCTIONS_SELECTED_END: 'AUCTIONS_SELECTED_END',
  AUCTIONS_SELECTED_END_SUCCESS: 'AUCTIONS_SELECTED_END_SUCCESS',
  AUCTIONS_SELECTED_END_FAIL: 'AUCTIONS_SELECTED_END_FAIL',

  AUCTION_COMMENT: 'AUCTION_COMMENT',
  AUCTION_COMMENT_SUCCESS: 'AUCTION_COMMENT_SUCCESS',
  AUCTION_COMMENT_FAIL: 'AUCTION_COMMENT_FAIL',

  AUCTION_ACCEPT: 'AUCTION_ACCEPT',
  AUCTION_ACCEPT_SUCCESS: 'AUCTION_ACCEPT_SUCCESS',
  AUCTION_ACCEPT_FAIL: 'AUCTION_ACCEPT_FAIL',

  AUCTION_DISPATCH: 'AUCTION_DISPATCH',
  AUCTION_DISPATCH_SUCCESS: 'AUCTION_DISPATCH_SUCCESS',
  AUCTION_DISPATCH_FAIL: 'AUCTION_DISPATCH_FAIL',

  AUCTION_REJECT: 'AUCTION_REJECT',
  AUCTION_REJECT_SUCCESS: 'AUCTION_REJECT_SUCCESS',
  AUCTION_REJECT_FAIL: 'AUCTION_REJECT_FAIL',

  AUCTIONS_CANCEL: 'AUCTIONS_CANCEL',
  AUCTIONS_CANCEL_SUCCESS: 'AUCTIONS_CANCEL_SUCCESS',
  AUCTIONS_CANCEL_FAIL: 'AUCTIONS_CANCEL_FAIL',

  AUCTION_CREATE_BIDS: 'AUCTION_CREATE_BIDS',
  AUCTION_CREATE_BIDS_SUCCESS: 'AUCTION_CREATE_BIDS_SUCCESS',
  AUCTION_CREATE_BIDS_FAIL: 'AUCTION_CREATE_BIDS_FAIL',

  SET_AUCTIONS_GRID_FILTER: 'SET_AUCTIONS_GRID_FILTER',
  CLEAR_AUCTIONS_GRID_FILTERS: 'CLEAR_AUCTIONS_GRID_FILTERS',

  SET_AUCTIONS_GRID_PAGE: 'SET_AUCTIONS_GRID_PAGE',
  CLEAR_AUCTIONS_GRID_PAGE: 'CLEAR_AUCTIONS_GRID_PAGE',

  AUCTIONS_EXPORT_PDF: 'AUCTIONS_EXPORT_PDF',
  AUCTIONS_EXPORT_PDF_SUCCESS: 'AUCTIONS_EXPORT_PDF_SUCCESS',
  AUCTIONS_EXPORT_PDF_FAIL: 'AUCTIONS_EXPORT_PDF_FAIL',

  AUCTIONS_FETCH_HISTORY: 'AUCTIONS_FETCH_HISTORY',
  AUCTIONS_FETCH_HISTORY_SUCCESS: 'AUCTIONS_FETCH_HISTORY_SUCCESS',
  AUCTIONS_FETCH_HISTORY_FAIL: 'AUCTIONS_FETCH_HISTORY_FAIL',
  AUCTIONS_CLEAR_HISTORY: 'AUCTIONS_CLEAR_HISTORY',

  NEW_AUCTION_SET_GARAGE: 'NEW_AUCTION_SET_GARAGE',
  NEW_AUCTION_CLEAR_GARAGE: 'NEW_AUCTION_CLEAR_GARAGE',

  NOTIFY_ONLINE_AUCTION_START: 'NOTIFY_ONLINE_AUCTION_START',
  NOTIFY_ONLINE_AUCTION_BID: 'NOTIFY_ONLINE_AUCTION_BID',
  NOTIFY_ONLINE_AUCTION_END: 'NOTIFY_ONLINE_AUCTION_END',
};

export const fetchAuction = (auctionId, forceRefresh) =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.AUCTION_FETCH, {
    auctionId,
    forceRefresh,
  });

export const fetchCurrentAuctions = skipStep =>
  ReduxHelper.createAction(
    AUCTIONS_ACTION_TYPES.AUCTIONS_FETCH_CURRENT,
    skipStep
  );
export const fetchNewAuctions = skipStep =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.AUCTIONS_FETCH_NEW, skipStep);
export const fetchParticipateToAuctions = skipStep =>
  ReduxHelper.createAction(
    AUCTIONS_ACTION_TYPES.AUCTIONS_FETCH_PARTICIPATETO,
    skipStep
  );
export const fetchOnlineAuctions = skipStep =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.AUCTIONS_FETCH_ONLINE);
export const fetchPendingApprovalAuctions = skipStep =>
  ReduxHelper.createAction(
    AUCTIONS_ACTION_TYPES.AUCTIONS_FETCH_PENDINGAPPROVAL,
    skipStep
  );
export const fetchNoOfferAuctions = skipStep =>
  ReduxHelper.createAction(
    AUCTIONS_ACTION_TYPES.AUCTIONS_FETCH_NOOFFER,
    skipStep
  );
export const fetchForSelectionAuctions = skipStep =>
  ReduxHelper.createAction(
    AUCTIONS_ACTION_TYPES.AUCTIONS_FETCH_FORSELECTION,
    skipStep
  );
export const fetchForAcceptanceAuctions = skipStep =>
  ReduxHelper.createAction(
    AUCTIONS_ACTION_TYPES.AUCTIONS_FETCH_FORACCEPTANCE,
    skipStep
  );
export const fetchRejectedAuctions = skipStep =>
  ReduxHelper.createAction(
    AUCTIONS_ACTION_TYPES.AUCTIONS_FETCH_REJECTED,
    skipStep
  );
export const fetchForDispatchAuctions = skipStep =>
  ReduxHelper.createAction(
    AUCTIONS_ACTION_TYPES.AUCTIONS_FETCH_FORDISPATCH,
    skipStep
  );
export const fetchDispatchProblemAuctions = skipStep =>
  ReduxHelper.createAction(
    AUCTIONS_ACTION_TYPES.AUCTIONS_FETCH_DISPATCHPROBLEM,
    skipStep
  );
export const fetchCompletedAuctions = skipStep =>
  ReduxHelper.createAction(
    AUCTIONS_ACTION_TYPES.AUCTIONS_FETCH_COMPLETED,
    skipStep
  );
export const fetchLostAuctions = () =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.AUCTIONS_FETCH_LOST);
export const fetchMerchantAuctionsSummary = () =>
  ReduxHelper.createAction(
    AUCTIONS_ACTION_TYPES.AUCTIONS_FETCH_MERCHANT_SUMMARY
  );

export const uploadAuction = (insuranceId, file, ownerInfo) =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.AUCTION_UPLOAD, {
    insuranceId,
    file,
    ownerInfo,
  });
export const clearUploadAuction = () =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.AUCTION_UPLOAD_CLEAR);

export const createAuction = (auctionData, folderData, garageData) =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.AUCTION_CREATE, {
    auctionData,
    folderData,
    garageData,
  });

export const editAuction = (auctionData, folderData) =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.AUCTION_EDIT, {
    auctionData,
    folderData,
  });

export const clearEditAuction = (auctionData, folderData) =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.AUCTION_EDIT_CLEAR);

export const commentAuction = (auctionId, auctionStatusId, comments) =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.AUCTION_COMMENT, {
    auctionId,
    auctionStatusId,
    comments,
  });

export const fetchComments = auctionId =>
  ReduxHelper.createAction(
    AUCTIONS_ACTION_TYPES.AUCTION_FETCH_COMMENTS,
    auctionId
  );

export const fetchParts = auctionId =>
  ReduxHelper.createAction(
    AUCTIONS_ACTION_TYPES.AUCTION_FETCH_PARTS,
    auctionId
  );

export const fetchBidsForAuction = auctionId =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.AUCTION_FETCH_BIDS, auctionId);
export const clearAuctionBids = auctionId =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.AUCTION_CLEAR_BIDS, auctionId);

export const clearAuctions = () =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.AUCTIONS_CLEAR);

export const clearCurrentAuction = () =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.AUCTION_CLEAR);

export const startAuctions = (auctions, comments, useDefaultValues) =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.AUCTIONS_START, {
    auctions,
    comments,
    useDefaultValues,
  });

export const endAuction = (bidId, ownerInfo) =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.AUCTION_END, {
    bidId,
    ownerInfo,
  });
export const endAuctions = auctionIds =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.AUCTIONS_SELECTED_END, {
    auctionIds,
  });

export const acceptAuction = (auctionId, garageId) =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.AUCTION_ACCEPT, {
    auctionId,
    garageId,
  });
export const rejectAuction = (auctionId, comments) =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.AUCTION_REJECT, {
    auctionId,
    comments,
  });
export const cancelAuctions = (auctionIds, reason) =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.AUCTIONS_CANCEL, {
    auctionIds,
    reason,
  });

export const exportToPdfCarAuctionPDF = auctionID =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.AUCTIONS_EXPORT_PDF, {
    auctionID,
  });

export const createAuctionBids = (auctionId, bidData, partyId) =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.AUCTION_CREATE_BIDS, {
    auctionId,
    bidData,
    partyId,
  });

export const setAuctionsGridFilter = (filterName, filterValue) =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.SET_AUCTIONS_GRID_FILTER, {
    name: filterName,
    value: filterValue,
  });
export const clearAuctionsGridFilter = () =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.CLEAR_AUCTIONS_GRID_FILTERS);

export const setAuctionsGridPage = pageNo =>
  ReduxHelper.createAction(
    AUCTIONS_ACTION_TYPES.SET_AUCTIONS_GRID_PAGE,
    pageNo
  );
export const clearAuctionsGridPage = () =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.CLEAR_AUCTIONS_GRID_PAGE);

export const fetchAuctionHistory = auctionId =>
  ReduxHelper.createAction(
    AUCTIONS_ACTION_TYPES.AUCTIONS_FETCH_HISTORY,
    auctionId
  );
export const clearAuctionHistory = () =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.AUCTIONS_CLEAR_HISTORY);

export const setNewAuctionGarage = garage =>
  ReduxHelper.createAction(
    AUCTIONS_ACTION_TYPES.NEW_AUCTION_SET_GARAGE,
    garage
  );
export const clearNewAuctionGarage = garage =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.NEW_AUCTION_CLEAR_GARAGE);

export const uploadImages = (auctionId, images) =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.AUCTION_UPLOAD_IMAGES, {
    auctionId,
    images,
  });
export const clearUploadImages = () =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.AUCTION_CLEAR_UPLOAD_IMAGES);

export const deleteImages = (auctionId, imageIds) =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.AUCTION_DELETE_IMAGES, {
    auctionId,
    imageIds,
  });
export const clearDeleteImages = () =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.AUCTION_CLEAR_DELETE_IMAGES);

export const reorderImages = (auctionId, imageIds) =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.AUCTION_REORDER_IMAGES, {
    auctionId,
    imageIds,
  });
export const clearReorderImages = () =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.AUCTION_CLEAR_REORDER_IMAGES);

export const fetchImages = id =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.AUCTION_FETCH_IMAGES, id);
export const clearImages = () =>
  ReduxHelper.createAction(AUCTIONS_ACTION_TYPES.AUCTION_CLEAR_IMAGES);

export const removeImageLicensePlate = (auctionId, imageId, obj) =>
  ReduxHelper.createAction(
    AUCTIONS_ACTION_TYPES.AUCTIONS_REMOVE_IMAGE_LICENSE_PLATE,
    { auctionId, imageId, ...obj }
  );
export const clearRemoveImageLicensePlate = () =>
  ReduxHelper.createAction(
    AUCTIONS_ACTION_TYPES.AUCTIONS_CLEAR_REMOVE_IMAGE_LICENSE_PLATE
  );

export const notifyLiveAuctionStart = auction =>
  ReduxHelper.createAction(
    AUCTIONS_ACTION_TYPES.NOTIFY_ONLINE_AUCTION_START,
    auction
  );
export const notifyLiveAuctionBid = data =>
  ReduxHelper.createAction(
    AUCTIONS_ACTION_TYPES.NOTIFY_ONLINE_AUCTION_BID,
    data
  );
export const notifyLiveAuctionEnd = auction =>
  ReduxHelper.createAction(
    AUCTIONS_ACTION_TYPES.NOTIFY_ONLINE_AUCTION_END,
    auction
  );
